import { useMutation as reactQueryUseMutation } from '@tanstack/react-query';

const useMutation = params => reactQueryUseMutation(params);

export default useMutation;
